import Auth from '@/infrastructure/api/helper/Auth';
import {移動入力在庫場所結果型, 移動登録型} from '@/type/movement/records/register/部署間移動入力';
import {移動修正依頼型, 移動修正検索依頼型, 移動修正登録者結果型, 移動削除依頼型, 移動修正検索結果型} from '@/type/movement/records/modify/部署間移動修正削除';
import {移動在庫商品型, 移動在庫商品検索依頼型, 移動在庫商品検索結果型} from '@/type/movement/records/register/移動商品検索';
import {移動履歴検索依頼型, 移動履歴検索結果型} from '@/type/movement/records/history/部署間移動履歴';
import {ハンディ移動削除依頼型, ハンディ移動取込依頼レコード型, ハンディ移動検索依頼型, ハンディ移動検索結果型} from '@/type/movement/records/handy/ハンディ移動取込';

export default {

    async 移動入力在庫場所一覧を取得する(): Promise<移動入力在庫場所結果型> {
        const auth = new Auth();
        const response = await auth.get('/api/movement/inventory_location');
        const 移動入力在庫場所結果 = response.data;
        return 移動入力在庫場所結果;
    },

    async 移動在庫商品一覧を取得する(移動在庫商品検索依頼: 移動在庫商品検索依頼型): Promise<移動在庫商品検索結果型> {
        const auth = new Auth();
        const response = await auth.post('/api/movement/product', 移動在庫商品検索依頼);
        const 移動在庫商品検索結果 = response.data;
        return 移動在庫商品検索結果;
    },

    async 移動を登録する(移動登録一覧: 移動登録型[]): Promise<void> {
        const auth = new Auth();
        const 移動登録依頼 = {
            移動登録依頼一覧: 移動登録一覧,
        };
        await auth.post('/api/movement/register', 移動登録依頼);
    },

    async 移動修正登録者一覧を取得する(): Promise<移動修正登録者結果型> {
        const auth = new Auth();
        const response = await auth.get('/api/movement/registrants');
        const 登録者一覧 = response.data;
        return 登録者一覧;
    },

    async 移動修正一覧を取得する(移動修正検索依頼: 移動修正検索依頼型): Promise<移動修正検索結果型> {
        const auth = new Auth();
        const response = await auth.post('/api/movement/list', 移動修正検索依頼);
        const 移動修正検索結果 = response.data;
        return 移動修正検索結果;
    },

    async 移動を削除する(移動削除依頼: 移動削除依頼型): Promise<void> {
        const auth = new Auth();
        await auth.post('/api/movement/delete', 移動削除依頼);
    },

    async 移動を修正する(移動修正依頼: 移動修正依頼型): Promise<void> {
        const auth = new Auth();
        await auth.post('/api/movement/update', 移動修正依頼);
    },

    async 移動履歴一覧を取得する(移動履歴検索依頼: 移動履歴検索依頼型): Promise<移動履歴検索結果型> {
        const auth = new Auth();
        const response = await auth.post('/api/movement/reference', 移動履歴検索依頼);
        const 移動履歴一覧 = response.data;
        return 移動履歴一覧;
    },

    async ハンディ移動を検索する(ハンディ移動検索依頼: ハンディ移動検索依頼型): Promise<ハンディ移動検索結果型> {
        const auth = new Auth();
        const response = await auth.post('/api/movement/handy/search', ハンディ移動検索依頼);
        const ハンディ移動検索結果 = response.data;
        return ハンディ移動検索結果;
    },

    async ハンディ移動を削除する(ハンディ移動削除依頼: ハンディ移動削除依頼型): Promise<void> {
        const auth = new Auth();
        await auth.post('/api/movement/handy/delete', ハンディ移動削除依頼);
    },

    async ハンディ移動を取り込む(ハンディ移動取込一覧: ハンディ移動取込依頼レコード型[]): Promise<void> {
        const auth = new Auth();
        const ハンディ取込依頼 = {
            ハンディ移動取込依頼レコード一覧: ハンディ移動取込一覧,
        };
        await auth.post('/api/movement/handy/import', ハンディ取込依頼);
    },
};

